import React from 'react'

const CallReceivedIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill={'green'}
    width="40"
    height="40"
    viewBox="0 0 24 24"
  >
    <title>Call received</title>
    <path d="M0 0h24v24H0z" fill="none" />
    <path d="M20 5.41L18.59 4 7 15.59V9H5v10h10v-2H8.41z" />
  </svg>
  )

export default CallReceivedIcon



// WEBPACK FOOTER //
// ./src/components/assets/CallReceivedIcon.js